export const LocalStorageKeys = {
    activeStoreId: "activeStoreId",
};
